import { render, staticRenderFns } from "./QuotationDashboard.vue?vue&type=template&id=27c59f00&"
import script from "./QuotationDashboard.vue?vue&type=script&lang=js&"
export * from "./QuotationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports